<template>
    <section class="tabbed_content fluid_tabs cf" id="TransactionLogPage">
        <!-- <p id="mlr-intro" v-if="isUserLogged === false">
            Sign in to enter ticket numbers, see your profile and awards information, and redeem points. If you don’t have an account, create one for free by clicking the REGISTER button below.
        </p> -->
        <UserLoginVue v-if="isUserLogged === false"></UserLoginVue>
        <span v-if="isUserLogged">
            <AccountHeader :user="user" :pointsBalance="userPoints" v-if="userLoaded"></AccountHeader>
            <ul class="tab_nav cf">
                <li class="tLogTab loaded" :class="{'selected': tabpoints}" @click="tabpoints=true;mobile=false;">
                    MyLotto Rewards<sup>&reg;</sup> Point Transactions
                </li>
                <li class="tLogTab" :class="{'selected': mobile}" v-if="mobileCashing" @click="getCashlessTLog">
                <!-- <li class="tLogTab" :class="{'selected': mobile}" v-if="mobileCashing" @click="testCashlessTLog"> -->
                    Mobile Cashing Transaction History
                </li>
            </ul>
            <div class="tab_content_srap first_active cf clear">
                <div class="tab_content module module_callOut current_content" id="tab_content_1" v-if="tabpoints">
                    <h3>
                        MyLotto Rewards<sup>&reg;</sup> Point Transactions
                    </h3>
                    <span>
                        <div class="transactionFilter cf">
                            <div class="date-fields">
                                <div class="fields-from">
                                    <label for="txtDateFrom" class="date-label" id="txtDateFromLabel">From:</label>
                                    <!-- <Datepicker :disabledDates="disabledDates" :placeholder="getStartDate" name="startDate" :format="customFormatter"></Datepicker> -->
                                    <input type="date" id="txtDateFrom" class="txtDateFrom date-archive picker__input" aria-haspopup="true" aria-readonly="false" aria-owns="txtDateFrom_root" @change="setStartDate" :value="startDate" :max="maxDate" :min="minDate">
                                </div>
                                <div class="fields-to">
                                    <label for="txtDateTo" class="date-label" id="txtDateToLabel">To:</label>
                                    <input type="date" id="txtDateTo" class="txtDateTo date-archive packer__input" aria-haspopup="true" aria-readonly="false" aria-owns="txtDateTo_root" @change="setEndDate" :value="endDate" :max="maxDate" :min="minDate">
                                </div>
                            </div>
                            <span class="btn">
                                <button class="button btn_filterSubmit js_tLogFilter" @click="getTLog">Update</button>
                            </span>
                            <span v-if="totalPages > 1">
                                <Pagination :totalPages="totalPages" :itemsPerPage="itemsPerPage" :currentPage="currentPage" @changePage="changePage" :center="true" :right="true"></Pagination>
                            </span>
                        </div>
                        <div id="transactionLog" class="transactionLog_MLR transactionLog cf" v-if="currentItems.length > 0">
                            <ul class="listHeader cf">
                                <li class="col1 listHead">
                                    Date
                                </li>
                                <li class="col2 listHead">
                                    Details
                                </li>
                                <li class="col3 listHead">
                                    Points
                                </li>
                                <!-- <li class="col4 listHead">
                                    Balance
                                </li> -->
                            </ul>
                            <ul class="transactionList">
                                <li v-for="(log, index) in currentItems" :key="index" class="transLI cf TLogRow">
                                    <div class="transDate">
                                        {{ log.operationDate }}
                                    </div>
                                    <div class="transAmount">
                                        {{ log.itemAmount }}
                                    </div>
                                    <!-- <div class="transBalance">
                                        {{ log.newBalance }}
                                    </div> -->
                                    <div class="transType cf">
                                        {{ log.itemDescription }}
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <h4 v-if="currentItems.length < 1">There are no transactions to display.</h4>
                    </span>
                </div>

                <div class="tab_content module module_callOut current_content" id="tab_content_1" v-if="mobile">
                    <h3>
                        MyLotto Rewards<sup>&reg;</sup> Mobile Transactions
                    </h3>
                    <span>
                        <div class="transactionFilter cf">
                            <div class="date-fields">
                                <div class="fields-from">
                                    <label for="txtDateFrom" class="date-label" id="txtDateFromLabel">From:</label>
                                    <input type="date" id="txtDateFrom" class="txtDateFrom date-archive picker__input" aria-haspopup="true" aria-readonly="false" aria-owns="txtDateFrom_root" @change="setStartDate" :value="startDate" :max="maxDate" :min="minDate">
                                </div>
                                <div class="fields-to">
                                    <label for="txtDateTo" class="date-label" id="txtDateToLabel">To:</label>
                                    <input type="date" id="txtDateTo" class="txtDateTo date-archive packer__input" aria-haspopup="true" aria-readonly="false" aria-owns="txtDateTo_root" @change="setEndDate" :value="endDate" :max="maxDate" :min="minDate">
                                </div>
                            </div>
                            <span class="btn">
                                <button class="button btn_filterSubmit js_tLogFilter" @click="getCashlessTLog">Update</button>
                            </span>
                            <span v-if="totalPages > 1">
                                <Pagination :totalPages="totalPages" :itemsPerPage="itemsPerPage" :currentPage="currentPage" @changePage="changePage" :center="true" :right="true"></Pagination>
                            </span>
                        </div>
                        <div id="transactionLog" class="transactionLog_MLR transactionLog cf" v-if="mobileItems.length > 0">
                            <ul class="listHeader cf">
                                <li class="col1 listHead">
                                    Date
                                </li>
                                <li class="col2 listHead">
                                    Transaction ID
                                </li>
                                <li class="col3 listHead">
                                    
                                </li>
                                <li class="col4 listHead">
                                    Payment
                                </li>
                            </ul>
                            <ul class="transactionList">
                                <li v-for="(log, index) in mobileItems" :key="index" class="transLI TLogRow">
                                    <div class="transDate col1">
                                        {{ log.operationDate }}
                                    </div>
                                    <div class="transAmount serial col2">
                                        {{ log.ticketSerial }}
                                    </div>
                                    <div class="transBalance link col3" v-if="log.view" @click="log.view = false">
                                        Hide
                                    </div>
                                    <div class="transBalance link col3" v-if="!log.view" @click="log.view = true">
                                        Show
                                    </div>
                                    <div class="transBalance col4">
                                        {{ log.payAmount }}
                                    </div>
                                    <TDetail :transtaction="log" v-if="log.view"></TDetail>
                                </li>
                            </ul>
                        </div>
                        <h4 v-if="mobileItems.length < 1">There are no transactions to display.</h4>
                    </span>
                </div>
            </div>
        </span>
    </section>
</template>

<script>
    // import $ from 'jquery';
    import moment from "moment";
    import Pagination from '../Pagination/pagination.vue';
    import UserLoginVue from '../../ViewComponents/SignInRegister/SignInRegister.vue';
    import Datepicker from "vue-moment-datepicker";
    import AccountHeader from './MyAccountHeader.vue';
    import TDetail from './TLogCashlessDetail.vue';

    export default {
        components: {
           Pagination,
           UserLoginVue,
           AccountHeader,
           Datepicker,
           TDetail
        },
        data: function () {
            return {
                viewDetail: false,
                isUserLogged: false,
                mobileCashing: false,
                tabpoints: true,
                mobile: false,
                token: '',
                user: 'false',
                tLog: '',
                cashlessLog: '',
                points: 0,
                disable: true,
                totalPages: 0,
                itemsPerPage: 10,
                currentPage: 1,
                currentItems: '',
                mobileItems: '',
                startDate: '',
                endDate: '',
                maxDate: '',
                minDate: '',
                disabledDates: {
                    from: new Date()
                },
                getStartDate: '',
                getEndDate: '',
                userPoints: 0,
                userInfo: '',
                userLoaded: false,
                testData: '{"statusCode":200,"message":"","error":null,"data":{"items":[{"description":"Cashed ticket: 00003982080188743680196498501731251","payAmount":1000,"ticketSerial":"00003982080188743680196498501731251","winAmount":1000,"payMethod":"BANK","gameIdentifier":null,"gameName":null,"date":"2023-08-25T09:45:24.927","userNotes":"Winning ticket for $1,000.00.","isError":false,"notes":"Winning ticket for $1,000.00.","stateTaxHeldAmount":0,"fedTaxHeldAmount":0,"odjfsHeldAmount":0,"agHeldAmount":0},{"description":"Cashed ticket: 00000497760000000280400368512436266","payAmount":1000,"ticketSerial":"00000497760000000280400368512436266","winAmount":1000,"payMethod":"BANK","gameIdentifier":null,"gameName":null,"date":"2023-08-24T15:10:54.09","userNotes":"Winning ticket for $1,000.00.","isError":false,"notes":"Winning ticket for $1,000.00.","stateTaxHeldAmount":0,"fedTaxHeldAmount":0,"odjfsHeldAmount":0,"agHeldAmount":0},{"description":"Cashed ticket: 22020096010298844160371243988347487","payAmount":1000,"ticketSerial":"22020096010298844160371243988347487","winAmount":1000,"payMethod":"BANK","gameIdentifier":null,"gameName":null,"date":"2023-08-22T18:18:02.797","userNotes":"Winning ticket for $1,000.00.","isError":false,"notes":"Winning ticket for $1,000.00.","stateTaxHeldAmount":0,"fedTaxHeldAmount":0,"odjfsHeldAmount":0,"agHeldAmount":0},{"description":"Cashed ticket: 34896610242348810244137517677347778","payAmount":1000,"ticketSerial":"34896610242348810244137517677347778","winAmount":1000,"payMethod":"BANK","gameIdentifier":null,"gameName":null,"date":"2023-08-22T15:14:26.813","userNotes":"Winning ticket for $1,000.00.","isError":false,"notes":"Winning ticket for $1,000.00.","stateTaxHeldAmount":0,"fedTaxHeldAmount":0,"odjfsHeldAmount":0,"agHeldAmount":0},{"description":"Cashed ticket: 00000061960017498112211108153530862","payAmount":1000,"ticketSerial":"00000061960017498112211108153530862","winAmount":1000,"payMethod":"BANK","gameIdentifier":null,"gameName":null,"date":"2023-08-22T14:50:22.85","userNotes":"Winning ticket for $1,000.00.","isError":false,"notes":"Winning ticket for $1,000.00.","stateTaxHeldAmount":0,"fedTaxHeldAmount":0,"odjfsHeldAmount":0,"agHeldAmount":0},{"description":"Cashed ticket: 01090519070000009440312994431022394","payAmount":1000,"ticketSerial":"01090519070000009440312994431022394","winAmount":1000,"payMethod":"BANK","gameIdentifier":null,"gameName":null,"date":"2023-08-16T19:13:12.913","userNotes":"Winning ticket for $1,000.00.","isError":false,"notes":"Winning ticket for $1,000.00.","stateTaxHeldAmount":0,"fedTaxHeldAmount":0,"odjfsHeldAmount":0,"agHeldAmount":0},{"description":"Cashed ticket: 10737422112415919128120567005108896","payAmount":100,"ticketSerial":"10737422112415919128120567005108896","winAmount":100,"payMethod":"BANK","gameIdentifier":null,"gameName":null,"date":"2023-08-10T17:44:57.943","userNotes":"Winning ticket for $100.00.","isError":false,"notes":"Winning ticket for $100.00.","stateTaxHeldAmount":0,"fedTaxHeldAmount":0,"odjfsHeldAmount":0,"agHeldAmount":0}],"gameImages":{},"totalRowCount":7}}'
            }
        },
        mounted: function () {
            this.getToken();
            this.getUser();

            this.startDate = moment().startOf('month').format('yyyy-MM-DD');
            this.getStartDate = moment(this.startDate).format('l');
            this.endDate = moment(new Date()).format('yyyy-MM-DD');
            // console.log(this.endDate)
            this.getEndDate = moment(this.endDate).format('l');

            this.maxDate = moment(new Date).toISOString().split("T")[0];
            // console.log(this.maxDate);
            // this.userInfo.user.userId = 2505551; // TESTING ID
            this.minDate = '2023-01-01';
        },
        methods: {
            customFormatter(date) {
                return moment(date).format('yyyy-MM-DD');
            },
            getToken() {
                this.getAPItoken()
                .then((token) => {
                    this.token = token;
                    this.userInfo = this.$cookies.get('apiToken');
                    this.setCashlessUser();
                    this.getTLog();
                    this.isUserLogged = this.isUserAuthed();
                });
            },
            getUser() {
                let users = this.$cookies.get('apiToken');
                let apiToken = users.token,
                    url = process.env.VUE_APP_APIURL + '/1.0/PAM/GetUser/' + users.user.userId;

                return fetch(url, {
                        method: 'GET',
                        headers: {
                            'Content-type': 'application/json',
                            'Authorization': "Bearer " + apiToken,
                        },
                    }
                )
                .then((response) => response.json())
                .then((json) => {
                    // console.log(json)
                    let data = json.data,
                        userData = data.userDto,
                        userPoints = userData.pointBalance;

                    this.user = data;
                    this.userLoaded = true
                })
            },
            getTLog() {
                let apiToken = this.token,
                    url = process.env.VUE_APP_APIURL + '/1.0/LogTransaction/TransactionLog/GetTransactionLogRecords';

                let datCreds = {
                            "userId": this.userInfo.user.userId,
                            "recordsPerPage": 1000,
                            "startDate": new Date(this.startDate),
                            "endDate": new Date(this.endDate),
                            "pageNumber": 1
                        };

                // console.log('Getting T-Log')

                return fetch(url, {
                        method: 'POST',
                        body: JSON.stringify(datCreds),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + apiToken,
                        },
                    }
                )
                .then((response) => response.json())
                .then((json) => {
                    let data = json.data,
                        userPointsStart = 0;

                    // console.log(data);

                    let items = [];

                    for (let i = 0; i < data.transactionLogItems.length; i++) {
                        let item = data.transactionLogItems[i];
                        // console.log('looping')
                        if (item.itemDescription === "TOTALUSERCREDIT") {
                            userPointsStart = userPointsStart + item.itemAmount;
                        }
                        // if (item.itemDescription === "PARTIALUSERCREDIT") {
                        //     userPointsStart = userPointsStart + item.itemAmount;
                        // }
                    }

                    let userPointsUpdated = userPointsStart;

                    for (let i = 0; i < data.transactionLogItems.length; i++) {
                        if (i > 0) {
                            let item = data.transactionLogItems[i],
                                date = new Date(item.operationDate);

                            if ( item.itemDescription === "PARTIALUSERCREDIT" || item.itemDescription === "TOTALUSERCREDIT" || item.itemDescription === "TOTALROWCOUNT" || item.itemDescription === "GAMEIDLIST") {
                                false
                            } else {
                                item.newBalance = userPointsUpdated;
                                // console.log(userPointsUpdated)
                                // console.log(item.itemAmount)
                                userPointsUpdated = userPointsUpdated + (item.itemAmount * -1);
                                // console.log(userPointsUpdated)
                                item.newBalance >= 1000 ? item.newBalance = item.newBalance.toLocaleString() : false;
                                item.itemAmount >= 1000 || item.itemAmount <= -1000 ? item.itemAmount = item.itemAmount.toLocaleString() : false;
                                // ------------------------------------------ //
                                date = moment(date).format("MM/DD/YYYY");
                                item.operationDate = date;

                                items.push(item);
                            }
                        }
                    }

                    this.userPoints = userPointsStart;
                    // console.log(this.userPoints);
                    this.tLog = items;
                    this.points = userPointsUpdated;
                    this.setPages();
                    this.setItems();
                })
                .catch((error) => {
                    // console.error("There was an error!", error);
                    return (this.errorMessage = error);
                });
            },
            testCashlessTLog() {
                this.tabpoints = false;
                this.mobile = true;
                // console.log('Getting Test')
                let dataParse = JSON.parse(this.testData),
                    data = dataParse.data;

                let items = [];

                for (let i = 0; i < data.items.length; i++) {
                    if (i > 1) {
                        let item = data.items[i],
                            date = item.date;

                        date = moment(date).format("L");
                        item.operationDate = date;
                        item.view = false;

                        items.push(item);
                    }
                }

                this.tLog = items;
                // console.log(this.tLog)
                this.setPages();
                this.setItems('a');
            },
            getCashlessTLog() {
                this.tabpoints = false;
                this.mobile = true;
                // console.log('getting mobile log')
                let apiToken = this.token,
                    url = process.env.VUE_APP_CASHLESSAPIURL + '/1.0/Cashless/User/GetCashlessTransactionItems?userId=' + this.userInfo.user.userId + '&startDate=' + this.startDate + '&endDate=' + this.endDate + '&recordsPerPage=1000&pageNumber=1&excludeErrorEntries=true';

                // let datCreds = {
                //             "userId": this.userInfo.user.userId,
                //             "recordsPerPage": 1000,
                //             "startDate": new Date(this.startDate),
                //             "endDate": new Date(this.endDate),
                //             "pageNumber": 1
                //         };

                return fetch(url, {
                        method: 'GET',
                        // body: JSON.stringify(datCreds),
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': "Bearer " + apiToken,
                        },
                    }
                )
                .then((response) => response.json())
                .then((json) => {
                    let data = json.data;

                    let items = [];

                    for (let i = 0; i < data.items.length; i++) {
                        // if (i > 1) {
                            let item = data.items[i],
                                date = item.date;

                            date = moment(date).format("L");
                            item.operationDate = date;
                            item.view = false;

                            items.push(item);
                        // }
                    }

                    this.tLog = items;
                    // console.log(this.tLog)
                    this.setPages();
                    this.setItems('a');
                })
                .catch((error) => {
                    // console.error("There was an error!", error);
                    return (this.errorMessage = error);
                });
            },
            setCashlessUser() {
                let user = this.$cookies.get('apiToken');

                for (let i = 0; i < user.user.listOfRoles.length; i++) {
                    let role = user.user.listOfRoles[i];

                    if (role === 'CashlessUser') {
                        this.mobileCashing = true;
                    }
                }
            },
            setPages() {
                this.itemsPerPage = 50;
                this.totalPages = Math.ceil(this.tLog.length / this.itemsPerPage);
                this.currentPage = 1;
            },
            changePage(p) {
                this.currentPage = p;
                // console.log(this.mobileCashing)
                if (this.mobileCashing) {
                    this.setItems("a");
                } else {
                    this.setItems();
                }
            },
            setItems(a) {
                let start = (this.itemsPerPage * this.currentPage) - this.itemsPerPage,
                    end = (this.itemsPerPage * this.currentPage),
                    currentItems = this.tLog.slice(start, end);

                if (a === "a") {
                    this.mobileItems = currentItems;
                    // console.log(this.mobileItems)
                    // console.log(this.currentPage)
                } else {
                    this.currentItems = currentItems;
                }
            },
            setStartDate(t) {
                let target = t;

                this.startDate = moment(target.target.value).format('yyyy-MM-DD');
                this.getStartDate = moment(target.target.value).format('l');
            },
            setEndDate(t) {
                let target = t;

                this.endDate = moment(target.target.value).format('yyyy-MM-DD');
                this.getEndDate = moment(target.target.value).format('l');
            }
		}
    };
</script>

<style lang="scss" scoped>
    #mlr-intro {
        padding: 0 10px;
        font-size: 1.4rem;
    }
</style>